import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function ShadcnUiToggleWrapper(
  props: {
    children: ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.SHADCN_UI}>
      {props.children}
    </ToggleWrapper>
  );
}
